import { render, staticRenderFns } from "./PatentsSearch.vue?vue&type=template&id=893adf18&"
import script from "./PatentsSearch.vue?vue&type=script&lang=js&"
export * from "./PatentsSearch.vue?vue&type=script&lang=js&"
import style0 from "./PatentsSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports